<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div>
    <modal
      v-if="true"
      :id="`${entityType}_file_upload_modal`"
      :visible="isVisible"
      :title="capitalize($t('actions.uploadFile'))"
      :body="isScreensFileUpload ? $t('messages.uploadScreensCSVFile') : $t('messages.uploadSitesCSVFile')"
      :form-fields="uploadCSVFileModalFormFields"
      :button1-caption="capitalize($t('actions.upload'))"
      :button2-caption="capitalize($t('actions.cancel'))"
      :button2-visible="true"
      @confirmed="csvUploadModalConfirmed"
      @cancelled="csvUploadModalCancelled">
      <template
        v-if="allowScreenAndSiteExclusion"
        #modal-after-text>
        <div class="row">
          <div class="col-sm-12">
            <tabs-slider
              width="100%"
              :selected-tab-i-d="selectedUploadOption"
              :tabs="[
                { id: 'include', name: capitalize($t('actions.includeList')) },
                { id: 'exclude', name: capitalize($t('actions.excludeList')) },
              ]"
              @selected-tab-changed="
                (option) => {
                  selectedUploadOption = option.id;
                }
              " />
          </div>
        </div>
      </template>
      <template #modal-after-form>
        <div class="flex-v-full">
          <span
            v-if="uploadError != null"
            class="alert alert-danger"
            >{{ uploadError }}</span
          >

          <div class="modal-section-separator">
            <div class="line" />
            <div class="text">
              {{ capitalize($t('actions.downloadATemplate')) }}
            </div>
            <div class="line" />
          </div>
          <!-- Show selections for download template when filtering for screen-->
          <div
            v-if="isScreensFileUpload"
            class="row">
            <div class="col-sm-12 field-help">
              <div
                class="text"
                :style="{ marginRight: '3rem' }">
                {{ $t('messages.downloadATemplateBasedOnFilteringMethod') }}
              </div>
              <div v-tooltip="capitalize($t('messages.screenIdVsUnitIdDefinition'))">
                <icon-info />
              </div>
            </div>
            <div :style="{ height: '1rem', width: '100%' }" />
            <div class="col-sm-12">
              <tabs-slider
                width="100%"
                :selected-tab-i-d="selectedFilterOption"
                :tabs="[
                  { id: 'screenID', name: capitalize($t('names.screenID', { n: 2 })) },
                  { id: 'unitID', name: capitalize($t('names.unitID', { n: 2 })) },
                ]"
                @selected-tab-changed="
                  (option) => {
                    selectedFilterOption = option.id;
                  }
                " />
              <div :style="{ height: '3rem', width: '100%' }" />
            </div>
          </div>
          <div class="file-templates">
            <div class="file-template">
              <a
                :download="`${entityType}-upload-template.csv`"
                :href="templateCSVData">
                <icon-file-c-s-v />
              </a>
            </div>

            <div class="file-template">
              <a
                :download="`${entityType}-upload-template.xlsx`"
                href="#"
                @click="downloadTemplateXLSXData">
                <icon-file-x-l-s />
              </a>
            </div>
          </div>
        </div>
      </template>
    </modal>

    <modal
      v-if="true"
      :visible="isInvalidCSVFileModalVisible"
      :title="capitalize($t('actions.uploadFile'))"
      :body="capitalize($t('messages.invalidCSVFile'))"
      :button1-caption="capitalize($t('actions.ok'))"
      @cancelled="isInvalidCSVFileModalVisible = false"
      @confirmed="isInvalidCSVFileModalVisible = false">
      <template #modal-after-form>
        <div class="flex-v-full">
          <p v-if="invalidFileAdditionalDetails != null">{{ invalidFileAdditionalDetails }}</p>
          <ul v-if="missingColumnNames != null">
            <li
              v-for="col in missingColumnNames"
              :key="col">
              {{ capitalize(col) }}
            </li>
          </ul>
          <a
            :download="`${entityType}-upload-template.csv`"
            :href="templateCSVData"
            >{{ $t('messages.downloadTemplateCSVFile') }}</a
          >
        </div>
      </template>
    </modal>
    <modal
      v-if="true"
      :visible="isInvalidXLSFileModalVisible"
      :title="capitalize($t('actions.uploadFile'))"
      :body="capitalize($t('messages.invalidXLSFile'))"
      :button1-caption="capitalize($t('actions.ok'))"
      @cancelled="isInvalidXLSFileModalVisible = false"
      @confirmed="isInvalidXLSFileModalVisible = false">
      <template #modal-after-form>
        <div>
          <p v-if="invalidFileAdditionalDetails != null">{{ invalidFileAdditionalDetails }}</p>
          <ul v-if="missingColumnNames != null">
            <li
              v-for="col in missingColumnNames"
              :key="col">
              {{ capitalize(col) }}
            </li>
          </ul>
          <!-- Show selections for download template when filtering for screen-->
          <div v-if="isScreensFileUpload">
            <div class="row">
              <div class="col-sm-12 field-help">
                <div
                  class="text"
                  :style="{ marginRight: '3rem' }">
                  {{ $t('messages.downloadATemplateBasedOnFilteringMethod') }}
                </div>
                <div v-tooltip="capitalize($t('messages.screenIdVsUnitIdDefinition'))">
                  <icon-info />
                </div>
              </div>
              <div :style="{ height: '1rem', width: '100%' }" />
              <div class="col-sm-12">
                <tabs-slider
                  width="100%"
                  :selected-tab-i-d="selectedFilterOption"
                  :tabs="[
                    { id: 'screenID', name: 'Screen IDs' },
                    { id: 'unitID', name: 'Unit IDs' },
                  ]"
                  @selected-tab-changed="
                    (option) => {
                      selectedFilterOption = option.id;
                    }
                  " />
                <div :style="{ height: '3rem', width: '100%' }" />
              </div>
            </div>
            <div class="file-templates">
              <div class="file-template">
                <a
                  :download="`${entityType}-upload-template.csv`"
                  :href="templateCSVData">
                  <icon-file-c-s-v />
                </a>
              </div>

              <div class="file-template">
                <a
                  :download="`${entityType}-upload-template.xlsx`"
                  href="#"
                  @click="downloadTemplateXLSXData">
                  <icon-file-x-l-s />
                </a>
              </div>
            </div>
          </div>
          <a
            v-else
            :download="`${entityType}-upload-template.xls`"
            @click="downloadTemplateXLSXData"
            >{{ $t('messages.downloadTemplateXLSFile') }}</a
          >
        </div>
      </template>
    </modal>

    <modal
      v-if="true"
      :id="`${entityType}_ids_file_upload_parsing_errors_modal`"
      :visible="isCSVParsingErrorsModalVisible"
      :title="capitalize($t('actions.uploadFile'))"
      :body="capitalize($t('messages.theFollowingRowsContainErrors'))"
      :button1-caption="capitalize($t('actions.ok'))"
      :button2-caption="capitalize($t('actions.dontImport'))"
      :button2-visible="true"
      size="lg"
      @confirmed="csvParsingErrorsModalConfirmed"
      @cancelled="csvParsingErrorsModalCancelled">
      <template #modal-after-form>
        <div v-if="csvParsingErrors != null">
          <table class="table table-striped table-bordered errors-table">
            <colgroup>
              <col width="20" />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>{{ capitalize($t('names.row', { n: 1 })) }}</th>
                <th>{{ capitalize($t('names.error', { n: 1 })) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="error in errors"
                :key="error.line">
                <td>{{ error.line }}</td>
                <td>{{ capitalize(error.message) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="file-errors-download">
            <a
              href="#"
              @click="downloadErrornousDataRows">
              <icon-file-x-l-s />
              {{ capitalize($t('actions.downloadRowsCausingErrors')) }}
            </a>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script type="text/babel">
  import Excel from 'exceljs';
  import Papa from 'papaparse';
  import { capitalize } from 'vue';

  import { TabsSlider } from '@/common/components/controls';
  import ModalFormField from '@/common/components/controls/modal/ModalFormField';
  import ModalFormFieldTypes from '@/common/components/controls/modal/ModalFormFieldTypes';
  import { IconFileCSV, IconFileXLS, IconInfo } from '@/common/icons/monochrome';
  import Exception from '@/common/models/Exception';
  import GlobalEventBus from '@/GlobalEventBus';
  import GlobalEvents from '@/GlobalEvents';
  import { generateCSVURI } from '@/utils/CsvUtils';
  import DownloadUtils from '@/utils/DownloadUtils';
  import i18n from '@/vueI18n';

  const SampleDatarowScreenScreenID = ['AA253'];

  const SampleDatarowScreenUnitID = ['100001'];

  const SampleDatarowSite = ['AA253'];

  export default {
    components: {
      IconFileCSV,
      IconFileXLS,
      IconInfo,
      TabsSlider,
    },
    props: {
      allowScreenAndSiteExclusion: {
        type: Boolean,
        default: false,
      },
      isScreensFileUpload: {
        type: Boolean,
        default: false,
      },
      isSitesFileUpload: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        csvParsingErrors: null,
        dataRowsThatFailed: [],
        invalidFileAdditionalDetails: null,
        isCSVParsingErrorsModalVisible: false,
        isInvalidCSVFileModalVisible: false,
        isInvalidXLSFileModalVisible: false,
        isVisible: false,
        screenIDsBeingImported: [],
        selectedUploadOption: 'include',
        selectedFilterOption: 'screenID',
        siteIDsBeingImported: [],
        missingColumnNames: null,

        filterOptions: [
          {
            value: 'screenID',
            name: 'Screen ID',
          },
          {
            value: 'unitID',
            name: 'Unit ID',
          },
        ],

        uploadCSVFileModalFormFields: [
          new ModalFormField({
            name: 'files',
            caption: capitalize(i18n.global.t('names.file', { n: 1 })),
            inputType: ModalFormFieldTypes.file,
            id: 'file-upload-input',
          }),
        ],
        uploadError: null,
      };
    },
    computed: {
      templateCSVData() {
        if (this.isScreensFileUpload) {
          if (this.selectedFilterOption === 'screenID') {
            return generateCSVURI([Object.values(this.dataColumns), SampleDatarowScreenScreenID]);
          }
          return generateCSVURI([Object.values(this.dataColumns), SampleDatarowScreenUnitID]);
        }
        return generateCSVURI([Object.values(this.dataColumns), SampleDatarowSite]);
      },
      entityType() {
        return this.isScreensFileUpload ? 'screen' : 'site';
      },
      dataColumns() {
        if (this.selectedFilterOption === 'unitID') {
          return { id: 'Unit ID' };
        }
        return { id: `${capitalize(this.entityType)} ID` };
      },
    },
    methods: {
      capitalize(text) {
        return capitalize(text);
      },
      processDataRows(dataRows) {
        const errors = [];
        const screenIDs = [];
        const siteIDs = [];
        const validDataRows = [];

        // Parse columns
        const [firstRow] = dataRows;
        const filterScreensByExternalID = this.isScreensFileUpload && firstRow.indexOf('Screen ID') > -1;
        const filterScreensByUnitID = this.isScreensFileUpload && firstRow.indexOf('Unit ID') > -1;

        let missingColumns = [];
        if (this.isScreensFileUpload) {
          if (!filterScreensByExternalID && !filterScreensByUnitID) {
            missingColumns = ['Screen ID or Unit ID'];
          }
        } else {
          missingColumns = Object.values(this.dataColumns).reduce(
            (mem, c) => (firstRow.includes(c) ? mem : [...mem, c]),
            [],
          );
        }

        if (missingColumns.length > 0) {
          throw new Exception({ code: 'missing-columns', value: missingColumns });
        }

        let columnIndex;
        if (this.isScreensFileUpload) {
          // In case the file has both Screen ID and Unit ID columns, filter using Unit ID
          if (filterScreensByExternalID && filterScreensByUnitID) {
            columnIndex = firstRow.indexOf('Unit ID');
          } else if (filterScreensByExternalID) {
            columnIndex = firstRow.indexOf('Screen ID');
          } else if (filterScreensByUnitID) {
            columnIndex = firstRow.indexOf('Unit ID');
          }
        } else {
          columnIndex = firstRow.indexOf(this.dataColumns.id);
        }

        const columnIndices = {
          id: columnIndex,
        };

        dataRows.forEach((x, i) => {
          if (i === 0) {
            return;
          }
          const id = `${x[columnIndices.id]}`;

          //
          // Validate data.
          //
          // const isMissingId = id == null || `${id}`.trim() === '';
          const errorLine = `${i + 1}`;
          let error = null;
          if (id == null || `${id}`.trim() === '') {
            error = { line: errorLine, message: `${capitalize(i18n.global.t('messages.nameIsMissing'))}`, dataRow: x };
          }

          if (error != null) {
            errors.push(error);
          } else {
            validDataRows.push({
              index: i + 2,
              id,
            });
          }
        });

        validDataRows.forEach((x) => {
          if (this.isScreensFileUpload) {
            screenIDs.push(x.id);
          } else {
            siteIDs.push(x.id);
          }
        });

        this.siteIDsBeingImported = siteIDs;
        this.screenIDsBeingImported = screenIDs;
        this.dataRowsThatFailed = [];
        GlobalEventBus.$emit(GlobalEvents.loaded);
        if (this.isScreensFileUpload) {
          this.$emit(
            'screenIDsImported',
            this.screenIDsBeingImported,
            this.selectedUploadOption,
            !filterScreensByUnitID,
          );
        } else {
          this.$emit('siteIDsImported', this.siteIDsBeingImported, this.selectedUploadOption);
        }
        this.isVisible = false;
        this.clearFileUploadInput();
      },
      async csvUploadModalConfirmed(formFields) {
        this.invalidFileAdditionalDetails = null;
        this.missingColumnNames = null;

        if (formFields[0].value == null || formFields[0].value[0] == null) {
          return;
        }
        GlobalEventBus.$emit(GlobalEvents.loading);
        const file = formFields[0].value[0];
        if (file.type === 'text/csv' || file.name.indexOf('.csv') > -1) {
          this.isUploadingCSV = true;
          Papa.parse(file, {
            keepEmptyRows: false,
            delimiter: ',',
            skipEmptyLines: true,
            complete: (result) => {
              if (result.errors.length > 0) {
                GlobalEventBus.$emit(GlobalEvents.loaded);
                this.isInvalidCSVFileModalVisible = true;
              } else {
                const dataRows = result.data; // All rows after the first.
                try {
                  this.processDataRows(dataRows);
                } catch (ex) {
                  switch (ex.error.code) {
                    case 'missing-columns':
                      this.invalidFileAdditionalDetails = i18n.global.t('messages.someColumnsAreMissing');
                      this.missingColumnNames = ex.error.value;
                      break;
                    default:
                      break;
                  }
                  GlobalEventBus.$emit(GlobalEvents.loaded);
                  this.isInvalidCSVFileModalVisible = true;
                }
              }
            },
          });
        } else if (
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.name.indexOf('.xlsx') > -1
        ) {
          this.isUploadingCSV = false;
          const fileReader = new window.FileReader();
          fileReader.onload = async (e) => {
            const workbook = new Excel.Workbook();
            try {
              await workbook.xlsx.load(e.target.result);
              const worksheet = workbook.getWorksheet(1);
              const dataRows = [];
              worksheet.eachRow((row) => {
                dataRows.push(row.values.slice(1)); // Index 0 is always empty, I guess to reflect Excel's 1-based index.
              });
              this.processDataRows(dataRows); // Remove headers.
            } catch (xlsxError) {
              if (xlsxError.error) {
                switch (xlsxError.error.code) {
                  case 'missing-columns':
                    this.invalidFileAdditionalDetails = i18n.global.t('messages.someColumnsAreMissing');
                    this.missingColumnNames = xlsxError.error.value;
                    break;
                  default:
                    this.invalidFileAdditionalDetails = null;
                    this.missingColumnNames = [];
                    break;
                }
              }
              GlobalEventBus.$emit(GlobalEvents.loaded);
              this.isInvalidXLSFileModalVisible = true;
            }
          };
          fileReader.onerror = (e) => {
            GlobalEventBus.$emit(GlobalEvents.loaded);
            this.isInvalidXLSFileModalVisible = true;
            console.log(e);
          };
          fileReader.readAsArrayBuffer(file);
        } else {
          this.uploadError = capitalize(i18n.global.t('messages.unsupportedFileFormat'));
          GlobalEventBus.$emit(GlobalEvents.loaded);
        }
      },
      csvUploadModalCancelled() {
        this.isVisible = false;
      },
      csvParsingErrorsModalConfirmed() {
        if (this.isScreensFileUpload) {
          this.$emit('screenIDsImported', this.screenIDsBeingImported);
        } else {
          this.$emit('siteIDsImported', this.siteIDsBeingImported);
        }
        this.isCSVParsingErrorsModalVisible = false;
      },
      csvParsingErrorsModalCancelled() {
        this.isCSVParsingErrorsModalVisible = false;
      },
      show() {
        this.csvParsingErrors = null;
        this.isVisible = true;
      },
      clearFileUploadInput() {
        document.getElementById('file-upload-input').value = '';
      },
      downloadErrornousDataRows() {
        const workbook = new Excel.Workbook();

        workbook.views = [
          {
            x: 0,
            y: 0,
            width: 30000,
            height: 20000,
            firstSheet: 0,
            activeTab: 1,
            visibility: 'visible',
          },
        ];

        const sheet = workbook.addWorksheet('IDs');
        const baseColumnWidth = 10;
        sheet.getColumn(1).width = 2 * baseColumnWidth;

        sheet.addRow(['ID']);
        this.errors.forEach((x) => {
          const data = [...x.dataRow];
          data[6] = x.message;
          sheet.addRow(data);
        });

        workbook.xlsx.writeBuffer().then((data) => {
          const blob = new window.Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          DownloadUtils.saveBlobToFile(blob, 'errors.xlsx');
        });
      },
      downloadTemplateXLSXData(e) {
        e.preventDefault();
        const workbook = new Excel.Workbook();

        workbook.views = [
          {
            x: 0,
            y: 0,
            width: 1000,
            height: 20000,
            firstSheet: 0,
            activeTab: 1,
            visibility: 'visible',
          },
        ];

        const sheet = workbook.addWorksheet('IDs');
        sheet.addRow(Object.values(this.dataColumns));

        if (this.isScreensFileUpload) {
          if (this.selectedFilterOption === 'screenID') {
            sheet.addRow(SampleDatarowScreenScreenID);
          } else {
            sheet.addRow(SampleDatarowScreenUnitID);
          }
        } else {
          sheet.addRow(SampleDatarowSite);
        }

        workbook.xlsx.writeBuffer().then((data) => {
          const blob = new window.Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          DownloadUtils.saveBlobToFile(blob, `${this.entityType}-upload-template.xlsx`);
        });
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .file-templates {
    display: flex;
    justify-content: space-around;

    .file-template {
      display: flex;
      flex-direction: column;
      align-content: center;

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      svg {
        stroke: var(--secondaryColor);
        fill: var(--secondaryColor);

        width: 4.8rem;
        height: 4.8rem;
        margin-right: 0.1rem;
        margin-bottom: 0.6rem;
      }

      &:first-of-type {
        svg {
          margin-left: 0.1rem;
          margin-right: 0;
        }
      }
    }
  }

  .file-errors-download {
    margin-top: 1.6rem;

    a {
      display: flex;
      flex-direction: row;
      align-content: center;

      svg {
        stroke: var(--secondaryColor);
        fill: var(--secondaryColor);

        width: 2rem;
        height: 2rem;
        margin-right: 0.6rem;
      }
    }
  }

  .alert-muted {
    margin-top: 1.6rem;
  }

  .errors-table {
    tbody {
      display: block;
      max-height: 30rem;
      overflow: auto;
    }

    thead,
    tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed; /* even columns width , fix width of table too*/

      td,
      th {
        &:first-of-type {
          width: 5rem;
        }

        width: 100%;
      }
    }

    thead {
      width: calc(100% - 1em); /* scrollbar is average 1em/16px width, remove it from thead width */
    }

    table {
      width: 60rem;
    }
  }
</style>
